import { CalendarComponent } from './modules/calendar/pages/calendar.component';
import { EulaComponent } from './pages/eula/eula.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LayoutComponent } from './modules/layout/layout.component';
import { MigFormComponent } from './modules/mig-form/mig-form.component';
import { MinervaPageComponent } from './pages/minerva-page/minerva-page.component';
import { MslaPageComponent } from './pages/msla-page/msla-page.component';
import { NgModule } from '@angular/core';
import { OurStoryPageComponent } from './pages/our-story-page/our-story-page.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { QualityOfLifePageComponent } from './pages/quality-of-life-page/quality-of-life-page.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ResidentEngagementPageComponent } from './pages/resident-engagement-page/resident-engagement-page.component';
import { ResidentExperiencesPageComponent } from './pages/resident-experiences-page/resident-experiences-page.component';
import { ResidentInsightsPageComponent } from './pages/resident-insights-page/resident-insights-page.component';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { SalesSupportToolPageComponent } from './pages/sales-support-tool-page/sales-support-tool-page.component';
import { SurveyFeedbackPlatformPageComponent } from './pages/survey-feedback-platform-page/survey-feedback-platform-page.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HomePageComponent,
      },
      {
        path: 'resident-engagement',
        component: ResidentEngagementPageComponent,
      },
      {
        path: 'minerva',
        component: MinervaPageComponent,
      },
      {
        path: 'our-story',
        component: OurStoryPageComponent,
      },
      {
        path: 'registration',
        component: RegistrationComponent,
        children: [
          {
            path: 'family-tree',
            loadChildren: () =>
              import('./modules/family-tree/family-tree.module').then(
                m => m.FamilyTreeModule
              ),
          },
          {
            path: 'my-page',
            loadChildren: () =>
              import('./modules/my-page/my-page.module').then(
                m => m.MyPageModule
              ),
          },
          {
            path: 'my-stories',
            loadChildren: () =>
              import('./modules/my-stories/my-stories.module').then(
                m => m.MyStoriesModule
              ),
          },
          {
            path: 'upon-registration',
            loadChildren: () =>
              import(
                './modules/upon-registration/upon-registration.module'
              ).then(m => m.UponRegistrationModule),
          },
          {
            path: 'wish-there',
            loadChildren: () =>
              import('./modules/wish-there/wish-there.module').then(
                m => m.WishThereModule
              ),
          },
        ],
      },
      {
        path: 'privacy',
        component: PolicyPageComponent,
      },
      {
        path: 'eula',
        component: EulaComponent,
      },
      {
        path: 'legal/msla',
        component: MslaPageComponent,
      },
      {
        path: 'Legal/msla',
        component: MslaPageComponent,
      },
      {
        path: 'resident-insights',
        component: ResidentInsightsPageComponent,
      },
      {
        path: 'resident-experiences',
        component: ResidentExperiencesPageComponent,
      },
      {
        path: 'quality-of-life',
        component: QualityOfLifePageComponent,
      },
      {
        path: 'sales-support-tool',
        component: SalesSupportToolPageComponent,
      },
      {
        path: 'survey-feedback-platform',
        component: SurveyFeedbackPlatformPageComponent,
      },
    ],
  },

  {
    path: 'communities/:oldCommunityId/public-calendar',
    component: CalendarComponent,
  },
  {
    path: 'communities/:oldCommunityId/public-calendar/:care-type-id',
    component: CalendarComponent,
  },
  {
    path: 'newsletter/:newsletterId',
    loadChildren: () =>
      import('./modules/newsletter/newsletter.module').then(
        m => m.NewsletterModule
      ),
  },
  {
    path: 'surveys',
    loadChildren: () =>
      import('@modules/feed-back/modules/surveys/surveys.module').then(
        m => m.SurveysModule
      ),
  },
  {
    path: 'mig-form',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('./modules/mig-form/mig-form.module').then(m => m.MigFormModule),
  },
  {
    path: 'mig-form?mode=test',
    component: MigFormComponent,
  },
  {
    path: ':hash/:slug',
    loadChildren: () =>
      import('./modules/wall-access/wall-access.module').then(
        m => m.WallAccessModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebSiteRoutingModule {}
